var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('selectable-categories',{attrs:{"items":_vm.value.categories,"grid-options":_vm.categoriesOptions,"show-chips":"","multiple":""},model:{value:(_vm.product),callback:function ($$v) {_vm.product=$$v},expression:"product"}})}
var staticRenderFns = []

export { render, staticRenderFns }